<template>
  <div>
    <!-- <search></search>
    <banner></banner>
    <lamp></lamp>
    <navtab></navtab>
    <swiper></swiper>
    <popular></popular>
    <brand></brand>
    <listtab></listtab> -->
  </div>
</template>

<script>
// import search from "@/components/search.vue";
// import banner from "@/components/banner.vue";
// import lamp from "@/components/lamp.vue";
// import navtab from "@/components/navtab.vue";
// import swiper from "@/components/swiper.vue";
// import popular from "@/components/popular.vue";
// import brand from "@/components/brand.vue";
// import listtab from "@/components/listtab.vue";
export default {
  components: {
    // search,
    // lamp,
    // navtab,
    // swiper,
    // popular,
    // brand,
    // banner,
    // listtab
  },
  props: {},
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style scoped>
</style>